import LangSet from './lang-set';

export default LangSet;
